import ContactMe from '../../sections/ContactMe'

export default function ContactPage() {
    return (
        <div className='mt-2'>
            <ContactMe />
        </div>
    )
}